/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import { Form, Icon } from 'semantic-ui-react';
import type { NavigationContentLink } from 'catalog/plugins/nav/simple';

type Props = {
  link: NavigationContentLink,
  onTitleChange: (title: string) => void,
  onSubTitleChange: (subTitle: string) => void,
};

const NavigationLinkForm = ({
  link,
  onTitleChange,
  onSubTitleChange,
}: Props) => {
  const titleChanged = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onTitleChange(event.target.value);
    }
  };

  //  const subTitleChanged = (event: SyntheticEvent) => {
  //    if (event.target instanceof HTMLInputElement) {
  //      onSubTitleChange(event.target.value);
  //    }
  //  };
  //  const fields = () => {
  //    switch (link.layout) {
  //      case 'image-title':
  //        return (
  //          <Form.Input
  //            label="Titre"
  //            value={link.title}
  //            onChange={titleChanged}
  //          />
  //        );
  //      case 'image-title-subtitle':
  //        return (
  //          <div>
  //            <Form.Input
  //              label="Titre"
  //              value={link.title}
  //              onChange={titleChanged}
  //            />
  //            <Form.Input
  //              label="Sous Titre"
  //              value={link.subTitle}
  //              onChange={subTitleChanged}
  //            />
  //            <div className="ui hidden divider" />
  //          </div>
  //        );
  //      case 'image-only':
  //      default:
  //        return null;
  //    }
  //  };

  return (
    <Form>
      <Form.Input label="Titre" value={link.title} onChange={titleChanged} />
      <Form.Input
        iconPosition="left"
        label="Liaison vers la page"
        value={link.page.name}
        readOnly
        action
      >
        <Icon name="chevron right" />
        <input />
        <Link
          to={`/pages/${link.page.id}`}
          target="innoctopus"
          className="ui button"
        >
          Editer
        </Link>
      </Form.Input>
    </Form>
  );
};

export default NavigationLinkForm;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/components/NavigationLinkForm.js